export default __webpack_public_path__ + "3f8d2424fa6c69dcefde1e2fff4714ef.png";